import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const fetchStockAdjustmentsList = (parameters = {}) => {
  const urlParams = getUrlParameters(parameters);
  
  return apiActionCreator({
    'endpoint': `/parts/stock-adjustment${urlParams}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_STOCK_ADJUSTMENTS_LIST,
      ActionTypes.FETCHED_STOCK_ADJUSTMENTS_LIST,
      [
        ActionTypes.FETCHED_STOCK_ADJUSTMENTS_LIST_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};
